import React, { Component } from 'react';
import './TimelinessChart.css';
import Chart from 'react-apexcharts';
import { v4 } from 'uuid';
import { ApexOptions } from 'apexcharts';
import moment from 'moment';

interface Props {
    data?: any[]
    startDate: string
    stopDate: string
    timeline_rows?: number
    data_labels?: string[]

    drag_mode?: boolean

    yFormatter?: (val: number, opts?: any) => string
    dataLabelFormatter?: (val: number, opts?: any) => string
    customTooltip?: ((options: any) => any) | ((options: any) => any)[]

    zoom_update: (startDate: string, stopDate: string) => void
}

const ROW_HEIGHT = 30;

export default class TimelinessChart extends Component<Props>{
    id: string

    constructor(props: Props) {
        super(props);
        this.id = v4();
    }

    timeline_height = () => {
        return (this.props.timeline_rows ? this.props.timeline_rows * ROW_HEIGHT : 300) + 22 + 46;
    }

    render() {
        if (!this.props.data) return null;
        else {
            return (
                <Chart
                    height={this.timeline_height()}
                    type="rangeBar"
                    series={this.props.data}
                    options={{
                        chart: {
                            id: this.id,
                            height: this.timeline_height(),
                            type: 'rangeBar',
                            animations: {
                                enabled: false
                            },
                            events: {
                                zoomed: (chart, options) => {
                                    // console.debug("zoomed",chart, options);
                                    this.props.zoom_update(options.xaxis.min, options.xaxis.max)
                                }
                            },
                            toolbar: {
                                tools: {
                                    reset: false,
                                    download: false,
                                    selection: false,
                                    pan: false,
                                    zoomin: false,
                                    zoomout: false,
                                },
                                show: false,
                                // autoSelected: 'selection'
                            },

                            zoom: {
                                enabled: true
                            }
                        },
                        tooltip: {
                            // style: {
                            //     fontSize: '5px',
                            // },
                            x: {
                                // formatter: (value)=>{
                                //     console.log("value?", value);
                                //     return moment(new Date(value)).format('YYYY-MM-DD h:mm');
                                // },
                                format: 'yyyy-MM-dd hh:mm',
                            },
                            y: {
                                formatter: this.props.yFormatter
                            },
                            custom: this.props.customTooltip,
                            // custom: 

                        },
                        xaxis: {
                            type: 'datetime',
                            min: new Date(this.props.startDate).getTime(),
                            max: new Date(this.props.stopDate).getTime(),
                            labels: {
                                formatter: value => {
                                    return moment(new Date(value)).format('YYYY-MM-DD h:mm')
                                },
                                style: {
                                    fontSize: "10px"
                                }
                            },
                            tickAmount: 8,
                            tickPlacement: 'between'
                        },
                        labels: this.props.data_labels,
                        dataLabels: {
                            enabled: !!this.props.dataLabelFormatter,
                            formatter: this.props.dataLabelFormatter
                        },
                        grid: {
                            row: {
                                colors: ['#f3f4f5', '#fff'],
                                opacity: 1
                            }
                        },
                        // fill:{
                        //     colors:["#326ce5"]
                        // },
                        legend: {
                            show: false
                        },
                        plotOptions: {
                            bar: {
                                horizontal: true,
                                rangeBarGroupRows: true,
                                barHeight: "70%",
                            }
                        },
                    }}
                />
            );
        }
    }
};
